<script setup>
import "@/styles/css/calculator-base.scss";
import "@/styles/css/seo-calculators.scss";
import { onMounted, ref } from "vue";
onMounted(() => {
  require("@/assets/js/calculator-base.js");
  require("@/assets/js/future-value.js");
});
const view = ref(false);
</script>
<template>
  <main class="upstox-calculators" id="future-value-calculator">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a href="/calculator/">
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>Future Value Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->

    <section class="calculator-background"></section>

    <section class="calculator">
      <div class="container">
        <h1 class="title">Future Value Calculator</h1>
        <div class="cal-structure">
          <div class="inner-row cal-slider" id="cal-slider">
            <div class="input-section calc-slide">
              <div class="calc-slide-inner">
                <div class="form-group investment-main">
                  <label for="investment">
                    <h3 id="investment-title">Present Value</h3>
                  </label>
                  <input
                    type="text"
                    id="investment"
                    value="₹ 25000"
                    class="input"
                    data-type="rupee"
                  />
                </div>
                <div class="form-group group-merge-top">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="investment-title">Interest Rate</h3>
                    </label>
                    <input
                      type="text"
                      value="12%"
                      step="0.1"
                      min="1"
                      max="100"
                      id="return-rate-input"
                      class="input"
                      data-type="percent"
                    />
                  </div>
                  <input
                    type="range"
                    value="12"
                    step="0.1"
                    min="1"
                    max="100"
                    id="return-rate-slider"
                    class="slider-range"
                  />
                </div>
                <div class="form-group group-merge-top">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="investment-title">No.of Periods Per Year</h3>
                    </label>
                    <input
                      type="text"
                      value="10"
                      step="1"
                      min="1"
                      max="365"
                      id="period-input"
                      class="input"
                      data-type="none"
                    />
                  </div>
                  <input
                    type="range"
                    value="10"
                    step="1"
                    min="1"
                    max="365"
                    id="period-input-slider"
                    class="slider-range"
                  />
                </div>
                <div class="form-group">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="investment-title">No.of Years</h3>
                    </label>
                    <input
                      type="text"
                      name="tenure"
                      value="10 years"
                      step="0.1"
                      min="1"
                      max="100"
                      id="numberofyear-input"
                      class="input"
                      data-type="years"
                    />
                  </div>
                  <input
                    type="range"
                    value="10"
                    step="0.1"
                    min="1"
                    max="100"
                    id="numberofyear-input-slider"
                    class="slider-range"
                  />
                </div>
                <div class="mob-calc-btn">
                  <button id="calculate" class="calc-btn-mob">Calculate</button>
                </div>
              </div>
            </div>
            <div class="output-section calc-slide cal-loader">
              <div class="calc-slide-inner">
                <lottie-player
                  src="/json-data/lottie/calculator-loader.json"
                  background="transparent"
                  speed="1"
                  loop=""
                  autoplay=""
                ></lottie-player>
              </div>
            </div>
            <div class="output-section calc-slide">
              <div class="calc-slide-inner">
                <div class="mob-results">
                  <h5>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/back-arrow.svg"
                      alt=""
                      id="back-button"
                    />
                    Your results
                  </h5>
                </div>
                <h3>Future value of your investment:</h3>
                <div class="distribution-bar background-color-bar">
                  <div class="grey investment" style="width: 887.554%"></div>
                  <div class="green returns" style="width: 9112.45%"></div>
                </div>
                <div class="invest-list">
                  <ul>
                    <li>
                      <span class="grey-circle"></span>
                      <h5>Present Value</h5>
                    </li>
                    <li>
                      <span class="green-circle"></span>
                      <h5>Future Value</h5>
                    </li>
                  </ul>
                </div>

                <div class="row outer-listing-group">
                  <div class="outer-grp">
                    <h4>Present Value</h4>
                    <span id="invested-amount">₹ 25,000</span>
                  </div>
                  <div class="outer-grp">
                    <h4>Total Interest</h4>
                    <span id="est-amount">₹ 2,56,673</span>
                  </div>
                  <div class="outer-grp">
                    <h4>Future Value</h4>
                    <span id="total-investment">₹ 2,81,673</span>
                  </div>
                  <div class="bottom-text">
                    <p>
                      <span class="capital-text">ZERO</span> annual maintenance
                      charges only for new users for the
                      <strong>next 10 days</strong>
                    </p>
                    <a
                      href="https://wa.me/+917092362098"
                      class="get-start-btn"
                      >Get Started Today</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--------------last 3 calculations -------------------->

    <section class="last-three-calculations">
      <div class="container last-three-cal-mobile">
        <h3>Last 3 calculations</h3>
        <p>Your calculations are erased upon refreshing!</p>
        <div class="calc-inner" id="cal-history"></div>
      </div>
    </section>

    <!--------------------Start Key Indicies Template--------------------------->

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in NSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/nifty-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 50"
                    />
                  </div>
                  <div class="key-content">NIFTY 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-next-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Next 50"
                    />
                  </div>
                  <div class="key-content">NIFTY NEXT 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-bank-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Bank"
                    />
                  </div>
                  <div class="key-content">NIFTY BANK</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 100"
                    />
                  </div>
                  <div class="key-content">NIFTY 100</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 200"
                    />
                  </div>
                  <div class="key-content">NIFTY 200</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 500"
                    />
                  </div>
                  <div class="key-content">NIFTY 500</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-midcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Midcap 50"
                    />
                  </div>
                  <div class="key-content">NIFTY MIDCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-smlcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="NIFTY SMLCAP 50"
                    />
                  </div>
                  <div class="key-content">NIFTY SMLCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/india-vix-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="India VIX"
                    />
                  </div>
                  <div class="key-content">INDIA VIX</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in BSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/sensex-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SENSEX"
                    />
                  </div>
                  <div class="key-content">SENSEX</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE100"
                    />
                  </div>
                  <div class="key-content">BSE100</div>
                </a>
              </li>
              <li>
                <a href="/indices/lrgcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="LRGCAP"
                    />
                  </div>
                  <div class="key-content">LRGCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/midcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="MIDCAP"
                    />
                  </div>
                  <div class="key-content">MIDCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/smlcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMLCAP"
                    />
                  </div>
                  <div class="key-content">SMLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE500"
                    />
                  </div>
                  <div class="key-content">BSE500</div>
                </a>
              </li>
              <li>
                <a href="/indices/allcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="ALLCAP"
                    />
                  </div>
                  <div class="key-content">ALLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE200"
                    />
                  </div>
                  <div class="key-content">BSE200</div>
                </a>
              </li>
              <li>
                <a href="/indices/bseipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSEIPO"
                    />
                  </div>
                  <div class="key-content">BSEIPO</div>
                </a>
              </li>
              <li>
                <a href="/indices/smeipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMEIPO"
                    />
                  </div>
                  <div class="key-content">SMEIPO</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!--------------------END Key Indicies Template--------------------------->

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>Future Value Calculator</h2>
      <p></p>
      <p>
        A key factor that guides one’s investments is the future value of the
        investment. But a key challenge most people face is this: How to
        evaluate the future value of one’s investments? This is an important
        question as it provides some clarity about one’s financial situation in
        the future, which in turn can help one to make more informed decisions.
        But calculating the future value of one’s investments may not be easy
        for many. This is where a future value calculator comes in handy.
      </p>
      <p>
        A future value calculator requires three inputs: principal amount, rate
        of interest and time period. Key in these three variables and the
        calculator shows the future value in no time. For example, if one
        invests ₹1 lakh for five years at 10% rate of interest, then at the end
        of the fifth year, the investor will get an amount of ₹161,051, which
        includes a compound interest of ₹61,051.
      </p>
      <p></p>
    </section>
    <!-- Calculator Faqs Section-->

    <section class="faqs">
      <div class="container">
        <div class="faq-card nav-list" id="faq">
          <div class="faq-card-details stock-card-header">
            <div class="faq-card-desc">
              <h2 class="heading">Frequently Asked Questions</h2>
            </div>
          </div>
          <div class="stock-card-content dynamic-faq">
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-1">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-1"
                  >
                    <span class="flex-grow"
                      >What is the formula to calculate future value?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What is the formula to calculate future value?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-1" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    The future value calculator uses the formula for compound
                    interest to ascertain the future value of an investment. The
                    formula is given as follows:
                  </p>
                  <p class="visible">A = p*(1+i)n</p>
                  <p class="visible">
                    where A = Amount (future value)<br />
                    P = principal (initial investment amount)<br />
                    i = the rate of interest per year<br />
                    n = tenure in years
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-2">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-2"
                  >
                    <span class="flex-grow"
                      >Why should I check the future value?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Why should I check the future value?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-2" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    The future value of an investment tells the investor how
                    much money they would get when their investment matures. For
                    example, assume that you have kept aside some money and want
                    to use it to buy a car worth ₹10 lakh three years from now.
                    You should get an idea of how much your savings will grow at
                    a given rate of interest at the end of three years. Checking
                    the future value of your money using a future value
                    calculator can help you make an informed decision.
                  </p>
                  <p class="visible">
                    You can also compare investments with the help of a future
                    value calculator. If you have a fair idea of what kind of
                    return you can get on a particular asset, then you can use
                    the future value calculator to figure out its future value.
                    For example, a lot of times asset owners keep getting offers
                    for their assets. If they know the future value and if they
                    can compare it with the price they can get now, then they
                    can make a more informed decision.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-3">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-3"
                  >
                    <span class="flex-grow"
                      >Is future value given by a future value calculator
                      accurate enough?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Is future value given by a future value calculator accurate enough?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-3" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Future value calculator is perfectly reliable when it comes
                    to the arithmetic part of the question. However, the future
                    value is computed based on the inputs given. If the holding
                    period or the rate of return assumed changes, then the
                    future value also changes. If investors’ assumption about
                    the rate of return is wrong, then the real world outcome of
                    the future value will be different from what is estimated by
                    the future value calculator.
                  </p>
                  <p class="visible">
                    The future value shown by a future value calculator does not
                    take into account the impact of taxes. Many investments
                    generate returns that are subsequently taxed. The future
                    value mentioned by a future value calculator does not
                    account for taxes payable.
                  </p>
                  <p class="visible">
                    Future value calculator also does not take into account the
                    real value of investments in the future. Real value of an
                    asset is derived by accounting for inflation. For example,
                    if the rate of interest is at 5% and the rate of inflation
                    is at 6%, then the real rate of return is arrived at by
                    deducting the rate of inflation from the rate of interest.
                    In the present situation, it is minus 1%. This means in real
                    terms an investor is losing value after investing.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-4">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-4"
                  >
                    <span class="flex-grow"
                      >How to compute future value of SIP investments?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How to compute future value of SIP investments?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-4" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Many investors invest in mutual funds through the systematic
                    investment plan (SIP) route. One needs to estimate the
                    future value of these units, if one has a rough idea about
                    the expected returns and the time frame. A future value
                    calculator cannot be used for computing the future value of
                    all SIP investments. One can use an
                    <a
                      href="/calculator/sip/"
                      target="_blank"
                      >SIP calculator</a
                    >
                    instead. It helps you to figure out the<br />
                    future value of all your SIP investments.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-5">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    href="#collapse-5"
                  >
                    <span class="flex-grow"
                      >Can a future value calculator help take corrective
                      actions?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Can a future value calculator help take corrective actions?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-5" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Most financial plans provide recommendations to invest in
                    various investment products. Each of these recommendations
                    is backed by some estimate of return and tenure. This is
                    done in light of the financial goals of an investor.
                    However, many times, financial goals change. Also, it is
                    observed that in some cases, the realised rate of return and
                    expected rate of return do not match.<br />
                    In such cases, one can estimate the future value of existing
                    investments and figure out the gaps. Accordingly, corrective
                    actions can be taken.
                  </p>
                  <p class="visible">
                    In the financial world, it is said that compounding interest
                    is the eighth wonder of the world. One who understands it
                    gains enormously from it, and one who does not understand it
                    pays for it. Hence, it is important to keep investing at
                    regular intervals and increase the future value of one’s
                    investment. Only this approach will help create wealth in
                    the long term.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button
            class="similar-btn btn-all"
            v-if="!view"
            @click="view = !view"
          >
            View all
          </button>
          <button
            class="similar-btn btn-less"
            v-if="view"
            @click="view = !view"
          >
            View less
          </button>
        </div>
        <div class="smooth-wrap" :class="view ? 'smooth-wrap2' : ''">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
